import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tr_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let redirecting = false;
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !redirecting) {
      redirecting = true; // first 401 decides; concurrent 401s must not overwrite the guest redirect
      let wasGuest = false;
      try { wasGuest = !!JSON.parse(localStorage.getItem("tr_user") || "null")?.is_guest; } catch { /* ignore */ }
      localStorage.removeItem("tr_token");
      localStorage.removeItem("tr_user");
      if (wasGuest) {
        window.location.href = "/scan?expired=1";
      } else if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      } else {
        redirecting = false;
      }
    }
    const d = err?.response?.data?.detail;
    if (err?.response?.status === 403 && d && typeof d === "object" && d.code === "upgrade_required") {
      window.dispatchEvent(new CustomEvent("tr-upgrade-required", { detail: d }));
    }
    if (err?.response?.status === 403 && d && typeof d === "object" && d.code === "guest_read_only") {
      window.dispatchEvent(new CustomEvent("tr-guest-blocked", { detail: d }));
    }
    return Promise.reject(err);
  }
);

export const errMsg = (e, fallback) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d && typeof d === "object" && d.message) return d.message;
  return fallback;
};

export const auth = {
  getUser: () => {
    try { return JSON.parse(localStorage.getItem("tr_user") || "null"); }
    catch { return null; }
  },
  getToken: () => localStorage.getItem("tr_token"),
  login: (token, user) => {
    localStorage.setItem("tr_token", token);
    localStorage.setItem("tr_user", JSON.stringify(user));
  },
  logout: () => {
    localStorage.removeItem("tr_token");
    localStorage.removeItem("tr_user");
  },
};
